import React from 'react';
import { Link } from 'react-router-dom';

// The little the assistant writes in: paragraphs, bullets, bold, and links.
// Internal paths become router links; everything else is text. No HTML.

const INLINE = /(\*\*[^*]+\*\*|\[[^\]]+\]\([^)\s]+\))/g;

function inline(text, keyBase) {
  const parts = text.split(INLINE).filter((p) => p !== '');
  return parts.map((part, i) => {
    const key = `${keyBase}-${i}`;
    if (part.startsWith('**') && part.endsWith('**')) return <strong key={key}>{part.slice(2, -2)}</strong>;
    const link = /^\[([^\]]+)\]\(([^)\s]+)\)$/.exec(part);
    if (link) {
      const [, label, href] = link;
      if (href.startsWith('/') && !href.startsWith('//')) return <Link key={key} to={href}>{label}</Link>;
      if (/^https?:\/\//.test(href)) return <a key={key} href={href} target="_blank" rel="noopener noreferrer">{label}</a>;
      return <span key={key}>{label}</span>;
    }
    return <React.Fragment key={key}>{part}</React.Fragment>;
  });
}

export default function Markdown({ text }) {
  if (!text) return null;
  const blocks = [];
  let list = null;
  let listType = null;
  const flush = () => { if (list) { blocks.push({ type: listType, items: list }); list = null; listType = null; } };
  for (const rawLine of text.split('\n')) {
    const line = rawLine.replace(/\s+$/, '');
    const bullet = /^\s*[-*•]\s+(.*)$/.exec(line);
    const numbered = /^\s*\d+[.)]\s+(.*)$/.exec(line);
    if (bullet || numbered) {
      const type = bullet ? 'ul' : 'ol';
      if (list && listType !== type) flush();
      if (!list) { list = []; listType = type; }
      list.push((bullet || numbered)[1]);
      continue;
    }
    flush();
    if (!line.trim()) continue;
    const heading = /^#{1,4}\s+(.*)$/.exec(line);
    if (heading) blocks.push({ type: 'h', text: heading[1] });
    else blocks.push({ type: 'p', text: line });
  }
  flush();
  return (
    <div className="md">
      {blocks.map((b, i) => {
        if (b.type === 'ul') return <ul key={i}>{b.items.map((it, j) => <li key={j}>{inline(it, `${i}-${j}`)}</li>)}</ul>;
        if (b.type === 'ol') return <ol key={i}>{b.items.map((it, j) => <li key={j}>{inline(it, `${i}-${j}`)}</li>)}</ol>;
        if (b.type === 'h') return <p key={i} className="md-heading">{inline(b.text, String(i))}</p>;
        return <p key={i}>{inline(b.text, String(i))}</p>;
      })}
    </div>
  );
}
